import tw from 'twin.macro'

export const MainStyles = tw.div`flex-1  h-100 overflow-y-auto`
